{
  "journalAudit.action.program.created": "Programme créé",
  "v8e.code.PROGRAM_SETTINGS_CONFLICT": "Le programme a été modifié entre-temps : rechargez-le avant d’enregistrer.",
  "v8e.code.PROJECT_ALREADY_ATTACHED": "Ce projet est déjà rattaché à un autre programme : détachez-le d’abord.",
  "v8e.code.PROJECT_ATTACHED_ELSEWHERE": "Ce projet est rattaché à un autre programme : rien à détacher ici.",
  "v8e.programmes.aucun": "Aucun programme dans l’organisation : créez le premier.",
  "v8e.programmes.aucun_choisi": "Choisissez un programme pour en voir le détail.",
  "v8e.programmes.aucun_resultat": "Aucun programme ne correspond à la recherche.",
  "v8e.programmes.choisir": "Voir {{nom}}",
  "v8e.programmes.creer.aucun_modele": "Aucun modèle de programme proposé : le programme suivra le modèle par défaut.",
  "v8e.programmes.creer.description": "Description (facultative)",
  "v8e.programmes.creer.geste": "Créer le programme",
  "v8e.programmes.creer.modele": "Modèle de programme",
  "v8e.programmes.creer.modele_aucun": "Modèle par défaut de la plateforme",
  "v8e.programmes.creer.modele_defaut": "{{nom}} (par défaut)",
  "v8e.programmes.creer.nom": "Nom du programme",
  "v8e.programmes.creer.propriete": "Vous en devenez propriétaire : vous administrez le programme et ses projets.",
  "v8e.programmes.creer.version_figee": "La version publiée du modèle est figée à la création.",
  "v8e.programmes.creer_un_programme": "Créer un programme",
  "v8e.programmes.lien.ouvrir": "Ouvrir le programme",
  "v8e.programmes.lien.projets": "Voir les projets de l’organisation",
  "v8e.programmes.liste": "les programmes de l’organisation",
  "v8e.programmes.nom_invalide": "Le nom du programme compte de 3 à 255 caractères.",
  "v8e.programmes.panneau.aucun_projet": "Aucun projet rattaché.",
  "v8e.programmes.panneau.modele": "Modèle",
  "v8e.programmes.panneau.modele_par_defaut": "Modèle par défaut",
  "v8e.programmes.panneau.projets_rattaches": "Projets rattachés ({{nombre}})",
  "v8e.programmes.panneau.proprietaires": "Propriétaires",
  "v8e.programmes.panneau.reglages": "les réglages du programme",
  "v8e.programmes.projets_comptes": "{{nombre}} projet(s)",
  "v8e.programmes.proprietaire": "propriétaire : {{nom}}",
  "v8e.programmes.rattacher.actuel": "« {{projet}} » est rattaché au programme « {{programme}} ».",
  "v8e.programmes.rattacher.choisir": "Choisir un programme",
  "v8e.programmes.rattacher.consequence_modele": "Le modèle et sa version restent ceux du projet.",
  "v8e.programmes.rattacher.consequence_profils": "Les profils tenus sur le programme valent aussi pour le projet.",
  "v8e.programmes.rattacher.detacher": "Détacher du programme",
  "v8e.programmes.rattacher.detacher_consequence": "Le projet quitte le programme « {{programme}} » ; ses choix hérités deviennent les siens.",
  "v8e.programmes.rattacher.detacher_d_abord": "Pour le rattacher à un autre programme, détachez-le d’abord.",
  "v8e.programmes.rattacher.detacher_titre": "Détacher « {{projet}} » de son programme ?",
  "v8e.programmes.rattacher.geste": "Rattacher",
  "v8e.programmes.rattacher.option_actuelle": "{{nom}} (actuel)",
  "v8e.programmes.rattacher.programme": "Programme",
  "v8e.programmes.rattacher.projet": "le projet",
  "v8e.programmes.rattacher.sans_programme": "« {{projet}} » n’est rattaché à aucun programme.",
  "v8e.programmes.recherche": "Rechercher un programme",
  "v8e.programmes.renommer.conflit": "Le programme a été modifié entre-temps : ses réglages viennent d’être relus, recommencez.",
  "v8e.programmes.renommer.geste": "Renommer le programme",
  "v8e.programmes.renommer.nom": "Nouveau nom",
  "v8e.programmes.renommer.reussi": "Programme renommé."
}
